import React from 'react';
import {FiAlignJustify} from 'react-icons/fi';
import {Link, useNavigate} from 'react-router-dom';
import {RiLogoutBoxFill, RiMoonFill, RiSunFill} from 'react-icons/ri';
import {formatCurrency} from '../../stores/JSHelper';
import AutoSuggest from '../autosuggest';
import {searchAccounts} from '../../stores/ApiHelper';
import UseAccountStore from '../../stores/DataStore';
import logo from '../../assets/img/cashflo-logo.png';
import UseLoginStore from '../../stores/LoginStore';
import {removeStorageItem, StorageKeys} from '../../stores/StorageHelper';
import {CENTRAL_ACCOUNT_ID} from '../../stores/Constants';
import {Account} from '../../stores/types';

const getSuggestions = async (value) => (value && value.length > 3 ? searchAccounts(value) : []);

const Navbar = (props: {onOpenSidenav: () => void; account: Account; secondary?: boolean | string}) => {
  const {onOpenSidenav, account} = props;
  const navigate = useNavigate();
  const [darkmode, setDarkmode] = React.useState(false);
  const {setAccount} = UseAccountStore();
  const {logout} = UseLoginStore();

  const onSuggestionSelected = (event, {suggestion}) => setAccount(suggestion.accountId);
  const renderSuggestion = (suggestion) => <span>{suggestion.name}</span>;

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <button onClick={() => setAccount(CENTRAL_ACCOUNT_ID)} className="font-bold capitalize hover:text-navy-700 dark:hover:text-white">
            <img src={logo} alt="logo" className="h-[20px]" />
          </button>
        </p>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link to="/" className="font-bold capitalize hover:text-navy-700 dark:hover:text-white">
            {account.name}
          </Link>
        </p>
      </div>
      <div className="ml-[6px]">
        <p className="shrink text-center text-[28px] capitalize text-navy-700 dark:text-white">
          <Link to="#" className="font-bold capitalize hover:text-navy-700 dark:hover:text-white">
            <small>Balance</small>: {formatCurrency(account.availableWalletBalance.balance, 'INR', false)}
          </Link>
        </p>
        <p className="shrink text-center text-[18px] font-bold capitalize text-navy-700 dark:text-white">
          <span title={formatCurrency(account.availableWalletBalance.availableBalance, 'INR', false)}>
            <small>Available</small>: {formatCurrency(account.availableWalletBalance.availableBalance, 'INR', true)}
          </span>{' '}~{' '}
          <span title={formatCurrency(account.availableWalletBalance.holdBalance, 'INR', false)}>
            <small>Pending</small>: {formatCurrency(account.availableWalletBalance.holdBalance, 'INR', true)} ({account.availableWalletBalance.holdCount})
          </span>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
          <AutoSuggest
            getSuggestions={getSuggestions}
            onSuggestionSelected={onSuggestionSelected}
            placeholder={'Switch account...'}
            renderSuggestion={renderSuggestion}
          />
        </div>
        <span className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden" onClick={onOpenSidenav}>
          <FiAlignJustify className="h-5 w-5" />
        </span>
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove('dark');
              setDarkmode(false);
            } else {
              document.body.classList.add('dark');
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" /> : <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />}
        </div>
        <div
          className="cursor-pointer text-gray-600"
          onClick={async () => {
            removeStorageItem(StorageKeys.AUTH_JWT_ACCESS_TOKEN);
            removeStorageItem(StorageKeys.ACTIVE_ACCOUNT_ID);
            await logout();
            navigate('/auth/login');
          }}
        >
          <RiLogoutBoxFill className="h-4 w-4 text-gray-600 dark:text-white" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
